const LOGOS_BY_LANGUAGE = {
  fr: [{ name: 'carrefour' }, { name: 'tesla' }, { name: 'renault' }, { name: 'decathlon' }, { name: 'laposte' }],
  es: [
    { name: 'santander' },
    { name: 'bbva' },
    { name: 'amazon' },
    { name: 'mercadona' },
    { name: 'carrefour' },
    { name: 'repsol' },
  ],
  de: [{ name: 'airbus' }, { name: 'bosch' }, { name: 'bmw' }, { name: 'siemens' }, { name: 'telekom' }],
  en: [{ name: 'apple' }, { name: 'dhl' }, { name: 'accenture' }, { name: 'amazon' }, { name: 'tesla' }],
  it: [{ name: 'tim' }, { name: 'unicredit' }, { name: 'lavazza' }, { name: 'carrefour' }, { name: 'amazon' }],
  pl: [{ name: 'rossmann' }, { name: 'allegro' }, { name: 'poczta' }, { name: 'zabka' }, { name: 'orlen' }],
  nl: [{ name: 'shell' }, { name: 'philips' }, { name: 'ing' }, { name: 'unilever' }, { name: 'heineken' }],
  pt: [{ name: 'air_portugal' }, { name: 'sonae' }, { name: 'jeronimo' }, { name: 'galp' }, { name: 'edp' }],
  ro: [{ name: 'orange' }, { name: 'kaufland' }, { name: 'continental' }, { name: 'petrol' }, { name: 'dacia' }],
  se: [{ name: 'ikea' }, { name: 'ericsson' }, { name: 'volvo' }, { name: 'h&m' }, { name: 'spotify' }],
  dk: [{ name: 'maersk' }, { name: 'novo_nordisk' }, { name: 'carlsberg' }, { name: 'danske_bank' }, { name: 'lego' }],
  fi: [{ name: 'stora_enso' }, { name: 'kone' }, { name: 'nokia' }, { name: 'neste' }, { name: 'upm_biofore' }],
  no: [{ name: 'yara' }, { name: 'telenor' }, { name: 'equinor' }, { name: 'aker' }, { name: 'dnb' }],
  lt: [{ name: 'maxima' }, { name: 'swedbank' }, { name: 'tele2' }, { name: 'novaturas' }, { name: 'seb' }],
  ee: [{ name: 'swedbank' }, { name: 'seb_group' }, { name: 'wise' }, { name: 'bolt' }, { name: 'g4s' }],
  cz: [{ name: 'cez' }, { name: 'ppf' }, { name: 'skoda' }, { name: 'seznam' }, { name: 'ceska' }],
  lv: [
    { name: 'swedbank' },
    { name: 'latvijas_pasts' },
    { name: 'air_baltic' },
    { name: 'seb_group' },
    { name: 'lmt' },
  ],
  gr: [
    { name: 'eurobank' },
    { name: 'national_bank' },
    { name: 'alpha_bank' },
    { name: 'ote' },
    { name: 'coca_cola_hbc' },
  ],
  rs: [
    { name: 'telenor' },
    { name: 'elektroprivreda_srbije' },
    { name: 'naftna_industrija_srbije' },
    { name: 'telekom_srbija' },
    { name: 'delta_holding' },
  ],
  bg: [
    { name: 'kaufland' },
    { name: 'aurubis' },
    { name: 'postbank' },
    { name: 'lidl' },
    { name: 'unicredit_bulbank' },
  ],
  si: [{ name: 'gorenje' }, { name: 'mercator' }, { name: 'krka' }, { name: 'petrol' }, { name: 'luka_koper' }],
  hr: [{ name: 'ina' }, { name: 'agrokor' }, { name: 'hep' }, { name: 'podravka' }, { name: 'atlantic_grupa' }],
  sk: [
    { name: 'kaufland' },
    { name: 'tatra_bank' },
    { name: 'united_states_steel' },
    { name: 'volkswagen' },
    { name: 'slovnaft' },
  ],
};

const LogoImage = ({ logo, isDuplicate = false }: { logo: { name: string }; isDuplicate?: boolean }) => (
  <img
    key={logo.name}
    src={`/images/home/hired-by/${logo.name}.svg`}
    alt={logo.name}
    className={isDuplicate ? 'md:hidden' : ''}
  />
);

export const LogoCarousel = ({ lang }: { lang: string }) => {
  const logos: { name: string }[] = LOGOS_BY_LANGUAGE[lang] || LOGOS_BY_LANGUAGE.fr;

  return (
    <div className="relative flex w-full overflow-hidden md:w-auto">
      <div className="flex animate-infinite-carousel gap-6 lg:animate-none">
        {logos.map((logo, index) => (
          <LogoImage key={index} logo={logo} />
        ))}

        {logos.map((logo, index) => (
          <LogoImage key={`duplicate-${index}`} logo={logo} isDuplicate={true} />
        ))}
      </div>
    </div>
  );
};
